import rebrandStyles from '@jobcase/react_pattern_library/styles/rebrand';

export const TABS = {
  JOBS: 'jobs',
  JOB_GROUPS: 'job_groups',
};

export const TABS_TITLES = {
  jobs: 'Jobs',
  job_groups: 'Job Groups',
};

export const DETAIL_TABS = {
  INFO: 'info',
  CANDIDATES: 'candidates',
  SPONSORSHIP: 'sponsorship',
  APPLICATION: 'application',
  SETTINGS: 'settings',
};

export const CAMPAIGNS_TABS = {
  INFO: 'info',
  SPONSORSHIP: 'sponsorship',
};

export const CAMPAIGNS_TABS_TITLES = {
  info: 'Info',
  sponsorship: 'Sponsorship',
};

export const DETAIL_TABS_TITLES = {
  info: 'Overview',
  candidates: 'Candidates',
  sponsorship: 'Sponsorship',
  application: 'Application',
  settings: 'Settings',
};

export const CREATE_JOBS_STEPS = {
  INFORMATION: 1,
  APPLICATION: 2,
  SETTINGS: 3,
};

export const CREATE_JOB_SPONSORSHIP_STEPS = {
  INFORMATION: 1,
  // hide partner sponsorship while we investigate, EMPD-6275
  // PARTNERS: 2,
  PAYMENT: 2,
  REVIEW: 3,
  RECEIPT: 4,
};

export const JOBS_SPONSORSHIP_RECEIPT_STATUS = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  PENDING_REQUEST_VERIFICATION: 'PENDING_REQUEST_VERIFICATION',
};

export const JOBS_SPONSORSHIP_STEPS_TITLES = {
  INFORMATION: 'Sponsor on Jobcase',
  INFORMATION_MOBILE: 'Choose Jobcase',
  PARTNERS: 'Choose partners',
  PAYMENT: 'Payment',
  REVIEW: 'Review',
};

export const JOBS_STEPS_TITLE = {
  INFORMATION: 'Information',
  APPLICATION: 'Application',
  SETTINGS: 'Settings',
};


export const SORT_OPTIONS = [
  {
    label: 'Newest created',
    value: 'date_created&true',
  },
  {
    label: 'Oldest created',
    value: 'date_created&false',
  },
  {
    label: 'Newest updated',
    value: 'last_updated&true',
  },
  {
    label: 'Oldest updated',
    value: 'last_updated&false',
  },
  {
    label: 'Most candidates',
    value: 'candidates&true',
  },
  {
    label: 'Fewest candidates',
    value: 'candidates&false',
  },
  {
    label: 'Job title A-Z',
    value: 'title&false',
  },
  {
    label: 'Job title Z-A',
    value: 'title&true',
  },
];

export const STATUS_LIST = {
  Active: 'Active',
  Inactive: 'Inactive',
  Pending: 'Pending',
};

export const TAG_BG_COLOR = {
  Active: rebrandStyles.color.lightSuccessColor,
  Inactive: rebrandStyles.color.lightErrorColor,
  Pending: rebrandStyles.color.lightBlueColor,
};

export const TYPE = {
  HOSTED: 'HOSTED',
  DIRECT: 'DIRECT',
  HOSTED_JC: 'HOSTED_JC',
};

export const JOBS_TYPE = {
  fulltime: 'Full-time',
  parttime: 'Part-time',
  contractor: 'Contractor',
  temporary: 'Temporary',
  internship: 'Temporary to Permanent',
};

export const RATE_TYPES = {
  HOUR: 'Per hour',
  WEEK: 'Per week',
  MONTH: 'Per month',
  YEAR: 'Per year',
};

export const INITIAL_INFO_STATE = {
  job_group: '',
  job_title: '',
  job_description: '',
  job_type: '',
  job_address: '',
  pay_minimum: '',
  pay_maximum: '',
  pay_rate: 'HOUR',
};

export const INITIAL_INFO_ERRORS_STATE = {
  job_group: false,
  job_title: false,
  job_description: false,
  job_type: false,
  job_address: false,
  zip: false,
  pay_minimum: false,
  pay_maximum: false,
  pay_range: false,
};

export const INITIAL_APPLICATION_ERRORS_STATE = {
  external_url: false,
};

export const INFO_STEP_FIELD_REFS = {
  job_group: 'job_group',
  job_title: 'job_title',
  job_description: 'job_description',
  job_type: 'job_type',
  job_address: 'job_address',
};

export const DUPLICATE_JOB_KEYS = [
  'external_url',
  'job_description',
  'is_organization_name_hidden',
  'is_resume_collected',
  'is_resume_needed',
  'questions',
  'notify_profiles',
];

export const JOB_TAG_BG_COLOR = {
  ACTIVE: rebrandStyles.color.lightSuccessColor,
  INACTIVE: rebrandStyles.color.lightErrorColor,
  PENDING: rebrandStyles.color.lightBlueColor,
};

export const DEACTIVATE_JOB_PROMPT = {
  headerText: 'Deactivate this job?',
  bodyText: 'This job listing will no longer be viewable to job seekers. '
  + 'You will still be able to view and edit this job in the employer center and interact with existing candidates. '
  + 'You can reactivate your job at any time.',
  primaryButtonText: 'Deactivate',
  showSecondaryButton: true,
  secondaryButtonText: 'Back',
  className: 'delete-confirmation-modal',
};

export const REACTIVATE_JOB_PROMPT = {
  headerText: 'Reactivate this job?',
  bodyText: 'Your job will be visible to job seekers again. Auto renew sponsorships will be resumed if applicable.',
  primaryButtonText: 'Reactivate',
  showSecondaryButton: true,
  secondaryButtonText: 'Back',
  className: 'reactivate-confirmation-modal',
};

export const CARD_MARGIN_BOTTOM = 16;
export const DEFAULT_CARD_HEIGHT = 200;

export const CARD_TYPE = {
  JOB: 'job',
  JOB_GROUP: 'job_group',
};

export const INITIAL_JOB_GROUP_STATE = {
  name: '',
  sub_organization_id: '',
  traffic_type: 'HOSTED',
};

export const INITIAL_JOB_GROUP_ERRORS_STATE = {
  name: false,
  sub_organization_id: false,
};

export const JOB_GROUP_FIELD_REFS = {
  name: 'name',
  sub_organization_id: 'sub_organization_id',
};

export const CANDIDATES_SORT_OPTIONS_VALUES = {
  APPLIED_AT_ASC: 'applied_at&true',
  APPLIED_AT_DESC: 'applied_at&false',
  RATING_ASC: 'rating_average&true',
  RATING_DESC: 'rating_average&false',
  FIRST_NAME_ASC: 'first_name&true',
  FIRST_NAME_DESC: 'first_name&false',
  LAST_NAME_ASC: 'last_name&true',
  LAST_NAME_DESC: 'last_name&false',
};

export const CANDIDATES_SORT_OPTIONS_LABELS = {
  [CANDIDATES_SORT_OPTIONS_VALUES.APPLIED_AT_ASC]: 'First applied',
  [CANDIDATES_SORT_OPTIONS_VALUES.APPLIED_AT_DESC]: 'Last applied',
  [CANDIDATES_SORT_OPTIONS_VALUES.RATING_DESC]: 'Highest rating',
  [CANDIDATES_SORT_OPTIONS_VALUES.RATING_ASC]: 'Lowest rating',
  [CANDIDATES_SORT_OPTIONS_VALUES.FIRST_NAME_ASC]: 'First name A-Z',
  [CANDIDATES_SORT_OPTIONS_VALUES.FIRST_NAME_DESC]: 'First name Z-A',
  [CANDIDATES_SORT_OPTIONS_VALUES.LAST_NAME_ASC]: 'Last name A-Z',
  [CANDIDATES_SORT_OPTIONS_VALUES.LAST_NAME_DESC]: 'Last name Z-A',
};

export const CANDIDATES_SORT_OPTIONS = [
  {
    label: 'Application date: Newest',
    value: CANDIDATES_SORT_OPTIONS_VALUES.APPLIED_AT_ASC,
  },
  {
    label: 'Application date: Oldest',
    value: CANDIDATES_SORT_OPTIONS_VALUES.APPLIED_AT_DESC,
  },
  {
    label: 'Highest rating',
    value: CANDIDATES_SORT_OPTIONS_VALUES.RATING_DESC,
  },
  {
    label: 'Lowest rating',
    value: CANDIDATES_SORT_OPTIONS_VALUES.RATING_ASC,
  },
  {
    label: 'First name A-Z',
    value: CANDIDATES_SORT_OPTIONS_VALUES.FIRST_NAME_ASC,
  },
  {
    label: 'First name Z-A',
    value: CANDIDATES_SORT_OPTIONS_VALUES.FIRST_NAME_DESC,
  },
  {
    label: 'Last name A-Z',
    value: CANDIDATES_SORT_OPTIONS_VALUES.LAST_NAME_ASC,
  },
  {
    label: 'Last name Z-A',
    value: CANDIDATES_SORT_OPTIONS_VALUES.LAST_NAME_DESC,
  },
];

export const JOB_SPONSORSHIP_STATUS_BG_COLOR = {
  PENDING: rebrandStyles.color.lightBlueColor,
  ON: rebrandStyles.color.lightSuccessColor,
  ACTIVE: rebrandStyles.color.lightSuccessColor,
  LOW: rebrandStyles.color.mediumYellowColor,
  OFF: rebrandStyles.color.lightErrorColor,
};

export const JOB_STATUS_TOOLTIP_CONTENT = {
  Active: {
    text: 'Your job is active and can be found by members on Jobcase.',
    offset: {
      left: -12,
      leftMobile: -5,
    },
    offsetHeader: {
      left: -12,
      leftMobile: -4,
    },
  },
  Inactive: {
    text: 'Your job is not active and is not actively being promoted on Jobcase or our partner sites.',
    offset: {
      left: -5,
      leftMobile: 0,
    },
    offsetHeader: {
      left: -6,
      leftMobile: 2,
    },
  },
  Pending: {
    text: 'Your organization has not been approved yet. Once approved by a member of the Jobcase team, your job will automatically be set to ‘Active’.',
    offset: {
      left: -5,
      leftMobile: 2,
    },
    offsetHeader: {
      left: -5,
      leftMobile: 3,
    },
  },
};

export const JOB_SPONSORSHIP_STATUS_TOOLTIP_CONTENT = {
  ON: {
    text: 'Your sponsorship is on, and your budget is currently being spent.',
    offset: {
      top: -125,
      topMobile: -145,
      left: -22,
      leftMobile: -15,
    },
  },
  LOW: {
    text: 'Your budget is currently low. You can update the renewal frequency or create a new sponsorship if you’d like.',
    offset: {
      top: -168,
      topMobile: -205,
      left: -22,
      leftMobile: -10,
    },
  },
  PENDING: {
    text: 'Your sponsorship is currently paused because your budget has been spent but it is set to renew. Depending on the frequency, it will be set to ‘On’.',
    offset: {
      top: -188,
      topMobile: -225,
      left: -5,
      leftMobile: 2,
    },
  },
};

export const RENEWAL_CARDS_CONTENT = {
  WEEKLY: {
    value: 'WEEKLY',
    title: 'Renew weekly',
    subtext: 'Renew the campaign once a week independent of remaining budget',
  },
  MONTHLY: {
    value: 'MONTHLY',
    title: 'Auto renew monthly',
    subtext: 'Renew the campaign once a month independent of remaining budget',
  },
  AUTO: {
    value: 'AUTO',
    title: 'When it runs out',
    subtext: 'Continuously renew this campaign each time your budget runs out',
  },
  NEVER: {
    value: 'NEVER',
    title: 'Never',
    subtext: 'Allow my campaign to run out and never renew',
  },
};

export const BUDGET_INFORMATION = {
  STEP: 25,
  MIN_LIMIT: 25,
};

export const INITIAL_STATE = {
  budget: 100,
  repeats: 'NEVER',
};

export const JOBS_INFO_STEP_ERROR_MESSAGES = {
  job_group: {
    required: () => 'A job group is required',
  },
  job_title: {
    required: () => 'Select or enter a job title for the listing',
  },
  job_description: {
    required: () => 'Enter a job description',
  },
  job_type: {
    required: () => 'Choose a job type',
  },
  job_address: {
    required: (hasZipCodeError = false) => (!hasZipCodeError ? 'Enter an address' : 'You must enter a zip code'),
  },
};

export const VALIDATE_JOB_INFO_STEP_FIELDS_FOR_IN_VALID_CHARS = [
  'job_title',
  'job_description',
  'job_address',
];

export const JOBS_APPLICATION_STEP_ERROR_MESSAGES = {
  external_url: {
    required: externalUrl => (!externalUrl ? 'Application link is required' : 'You must enter a valid URL'),
  },
};

export const PAY_TYPE = {
  PAY_RANGE: 0,
  SET_WAGE: 1,
};

export default {
  DETAIL_TABS,
  DETAIL_TABS_TITLES,
  CREATE_JOBS_STEPS,
  JOBS_STEPS_TITLE,
  SORT_OPTIONS,
  STATUS_LIST,
  TABS_TITLES,
  TABS,
  TAG_BG_COLOR,
  TYPE,
  JOB_TAG_BG_COLOR,
  DEACTIVATE_JOB_PROMPT,
  REACTIVATE_JOB_PROMPT,
  INFO_STEP_FIELD_REFS,
  DUPLICATE_JOB_KEYS,
  INITIAL_INFO_ERRORS_STATE,
  INITIAL_INFO_STATE,
  JOBS_TYPE,
  JOB_SPONSORSHIP_STATUS_BG_COLOR,
  RENEWAL_CARDS_CONTENT,
  BUDGET_INFORMATION,
  INITIAL_STATE,
  CAMPAIGNS_TABS,
  CAMPAIGNS_TABS_TITLES,
  JOB_STATUS_TOOLTIP_CONTENT,
  JOB_SPONSORSHIP_STATUS_TOOLTIP_CONTENT,
  JOBS_INFO_STEP_ERROR_MESSAGES,
  VALIDATE_JOB_INFO_STEP_FIELDS_FOR_IN_VALID_CHARS,
  JOBS_APPLICATION_STEP_ERROR_MESSAGES,
  PAY_TYPE,
};
